import React from "react";
import "./FAQ.css";
import {BasePage, page} from "./BasePage";
import { Collapse ,Select} from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import { SettingOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
function callback(e: any) {
	console.log(e);
}

@page("FAQ", "faq")
export class FAQ extends BasePage {
	// 没有会报错
	protected mobileContent(): JSX.Element {
		// 在这里完善内容
		return <div>
			<div className="title">FAQ</div>
			<div className="content">
				<Collapse accordion defaultActiveKey={['0']}>
					{this.data.map((item, i) => <Panel header={item.title} key={i}>
						<p>{item.content}</p>
					</Panel>)}
				</Collapse>
			</div>
		</div>
	}

	protected get data() {
		return [{
			title: 'What’s an NFT?',
			content: `NFT stands for “Non-Fungible Token” and is a fancy way of saying a unique, one-of-a-kind digital item that users can buy, own, and trade. Some NFTs function as digital art and look cool, some offer additional utility. Think of NFTs (Non-Fungible Tokens) as unique digital assets that are secured and contained on the blockchain.`
		},{
			title: 'What makes PokerDAO NFT so unique?',
			content: `PokerDAO NFTs are rare pieces of art that can also act as a “membership card” which grants you access to members-only perks. Unlike other Texas Hold'em platforms on the blockchain, PokerDAO hopes to build a Texas Hold'em club where people are keen to share and solve problems and make progress together`
		},{
			title: 'Why should I hold PokerDAO NFTs?',
			content: `PokerDAO NFT is also your key to our private Texas Hold’em Discord, giving you access to our exclusive content: such as teaching or playing against pros or even directly participating in big offline Texas Hold’em events, etc. After establishment of our platform, the holder will also receive additional token rewards given by PokerDAO when winning the pot with the same hand cards as your held NFT.`
		},{
			title: 'If I don\'t have an NFT, can I play on your platform?',
			content: `You don't need to hold an NFT to play on the platform, and your odds of winning do not change based on where or not you hold the NFT.`
		},{
			title: 'Will a new roadmap be announced in the future?',
			content: `At present, we are progressing through the Alpha roadmap. As active community members, NFT holders will gain more benefits and create friendships. Later we will release a more detailed roadmap for the Beta as well as future roadmap. This will be largely related to development of governance features across the entire platform, etc.`
		}];
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			<div className="title">FAQ</div>
			<div className="content">
				<Collapse accordion defaultActiveKey={['0']}>
					{this.data.map((item, i) => <Panel header={item.title} key={i}>
							<p>{item.content}</p>
						</Panel>)}
				</Collapse>
			</div>
		</div>
	}

}


